import { createApp } from 'vue';
import { i18n } from 'locales';
import projectStore from 'store/projects/project';
import ProjectCardsContainer from 'components/project/ProjectCardsContainer.vue';
import ProjectShowcaseCards from 'components/project/ProjectShowcaseCards.vue';
import ProjectCheckoutButton from 'components/project/ProjectCheckoutButton.vue';
import SharingModalContent from 'components/project/SharingModalContent.vue';
import uploadStore from 'store/upload';
import newProject from 'components/newProject/NewProject.vue';
import UploadProjectProgress from 'components/newProject/ProjectUploadProgress.vue';
import InvisibleUploadForm from 'components/newProject/InvisibleUploadForm.vue';

function initializeProjectComponents() {
  const app = createApp();
  app.use(i18n);
  app.use(projectStore);
  app.mount('#vue-revisions');

  const app2 = createApp();
  app2.component(ProjectCardsContainer.name, ProjectCardsContainer);
  app2.use(i18n);
  app2.use(projectStore);
  app2.mount('#vue-project-cards');

  const app3 = createApp();
  app3.component(ProjectShowcaseCards.name, ProjectShowcaseCards);
  app3.use(i18n);
  app3.use(projectStore);
  app3.mount('#vue-project-showcase');

  const app4 = createApp();
  app4.component(ProjectCheckoutButton.name, ProjectCheckoutButton);
  app4.use(i18n);
  app4.use(projectStore);
  app4.mount('#vue-project-checkout-button');

  const app5 = createApp();
  app5.component(SharingModalContent.name, SharingModalContent);
  app5.use(i18n);
  app5.use(projectStore);
  app5.mount('#vue-project-sharing-modal-content');
}

function initializeProjectUpload() {
  const mountElement = '#vue-project-upload';
  const uploadArea = document.querySelector(mountElement);
  if (uploadArea === null) {
    return;
  }

  const store = uploadStore(uploadArea.dataset.uploadPath);

  const app = createApp();
  app.use(i18n);
  app.use(store);
  app.component(UploadProjectProgress.name, UploadProjectProgress);
  app.component(InvisibleUploadForm.name, InvisibleUploadForm);
  app.component(newProject.name, newProject);
  app.mount(mountElement);
}

window.addEventListener('load', () => {
  initializeProjectUpload();
  initializeProjectComponents();
});
